import { EventEnum } from '@as-react/common-types';
import { CompareActionTypes, GeneralActionTypes, MonetateActionTypes, WishListActionTypes, } from '../../../enums/ActionEnums';
import { ScriptLoadingState } from '../../../enums/GeneralEnums';
import { updateWishListProducts, initializeWishListProducts } from '../../../redux/wishList/reducers/WishListReducer';
import { toggleComparedStateForItems } from '../../../redux/compare/reducers/CompareReducer';
import { updateProductGroupProducts } from '../../../util/ProductGroupUtil';
import { setDeliveryPromiseToProducts } from '../../../util/ProductUtil';
export const initialState = {
    scriptState: ScriptLoadingState.NOT_LOADED,
    recommendations: [],
    products: {},
};
const customEventReducer = (state, eventPayload) => {
    switch (eventPayload.eventType) {
        case EventEnum.MONETATE_RECOMMENDATIONS:
            return Object.assign(Object.assign({}, state), { recommendations: [...state.recommendations, Object.assign({}, eventPayload.data)] });
        default:
            return state;
    }
};
export const monetateReducer = (state = initialState, action) => {
    switch (action.type) {
        case GeneralActionTypes.CUSTOM_EVENT:
            return customEventReducer(state, action.payload);
        case MonetateActionTypes.LOAD:
            return Object.assign(Object.assign({}, state), { scriptState: ScriptLoadingState.LOADING });
        case MonetateActionTypes.ON_HOLD:
            return Object.assign(Object.assign({}, state), { scriptState: ScriptLoadingState.ON_HOLD });
        case MonetateActionTypes.LOADED:
            return Object.assign(Object.assign({}, state), { scriptState: ScriptLoadingState.LOADED });
        case MonetateActionTypes.SET_PRODUCTS:
            return Object.assign(Object.assign({}, state), { products: Object.assign(Object.assign({}, state.products), action.payload) });
        case MonetateActionTypes.SET_DELIVERY_PROMISE:
            return Object.assign(Object.assign({}, state), { products: Object.assign(Object.assign({}, state.products), { [action.payload.productGroupId]: setDeliveryPromiseToProducts(state.products[action.payload.productGroupId], action.payload) }) });
        case CompareActionTypes.COMPARE_UPDATE_PRODUCTS:
            return Object.assign(Object.assign({}, state), { products: updateProductGroupProducts(state.products, toggleComparedStateForItems, action.payload) });
        case WishListActionTypes.UPDATE_PRODUCTS:
            return Object.assign(Object.assign({}, state), { products: updateProductGroupProducts(state.products, initializeWishListProducts, action) });
        case WishListActionTypes.ADD_PRODUCT:
            return Object.assign(Object.assign({}, state), { products: updateProductGroupProducts(state.products, updateWishListProducts, action, true) });
        case WishListActionTypes.REMOVE_PRODUCT:
            return Object.assign(Object.assign({}, state), { products: updateProductGroupProducts(state.products, updateWishListProducts, action, false) });
        default:
            return state;
    }
};
